// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"120":"2a629a4c02256382df92","856":"88455aae6d93f95d8d1a","894":"08a1370d5e81eeae4e64"}[chunkId] + ".js";
};